import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-042c3430"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paid-div" }
const _hoisted_2 = { class: "pay-info" }
const _hoisted_3 = { class: "user-info" }
const _hoisted_4 = { class: "user-logo" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "user-desc" }
const _hoisted_7 = { class: "user-name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-msg" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://image.kilimall.com/kenya/new_wap/pay/paid_msg.png" })
], -1))
const _hoisted_9 = {
  key: 0,
  class: "order-info"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"order-status\" data-v-042c3430><div class=\"status-label\" data-v-042c3430>Payment amount：</div><div class=\"status-value\" data-v-042c3430><div class=\"value-icon\" data-v-042c3430><img src=\"https://image.kilimall.com/kenya/new_wap/pay/cancelled_paid.png\" data-v-042c3430></div></div></div><div class=\"order-price over\" data-v-042c3430>KSh 498</div>", 2)
const _hoisted_12 = [
  _hoisted_10
]
const _hoisted_13 = {
  key: 1,
  class: "order-info"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"order-status\" data-v-042c3430><div class=\"status-label\" data-v-042c3430>Payment amount：</div><div class=\"status-value\" data-v-042c3430><div class=\"value-icon\" data-v-042c3430><img src=\"https://image.kilimall.com/kenya/new_wap/pay/already_paid.png\" data-v-042c3430></div></div></div><div class=\"order-price over\" data-v-042c3430>KSh 498</div>", 2)
const _hoisted_16 = [
  _hoisted_14
]
const _hoisted_17 = { class: "order-info" }
const _hoisted_18 = { class: "order-status" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-label" }, "Payment amount：", -1))
const _hoisted_20 = {
  key: 0,
  class: "status-value"
}
const _hoisted_21 = {
  key: 1,
  class: "status-value"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://image.kilimall.com/kenya/new_wap/pay/already_paid.png" })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 2,
  class: "status-value"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://image.kilimall.com/kenya/new_wap/pay/cancelled_paid.png" })
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "product-info" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-title" }, "Order information", -1))
const _hoisted_30 = { class: "product-list" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "product-image" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "product-desc" }
const _hoisted_35 = { class: "name" }
const _hoisted_36 = { class: "spec" }
const _hoisted_37 = { class: "pay-submit-div" }
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"tip-div\" data-v-042c3430><div class=\"tip-item\" data-v-042c3430>Tips</div><div class=\"tip-item\" data-v-042c3430>1. Please confirm with your friend before the payment.</div><div class=\"tip-item\" data-v-042c3430>2. if you need a refund after the payment, please contact your friend to apply for a refund.</div><div class=\"tip-item\" data-v-042c3430>3. The order amount will be returned to the payer if refunded successfully.</div></div>", 1)

import { ref, inject, Ref } from 'vue';
import { useRoute, useRouter } from "vue-router"

interface orderInfo {
  amount: number,
  goods_list: any,
  member: any,
  payment_short_code: string,
  pay_url: string,
  status: number // 0取消, 10未支付, 20已支付
}

export default /*#__PURE__*/_defineComponent({
  __name: 'paid',
  setup(__props) {

const route: any = useRoute()
const router: any = useRouter()
const $http: any = inject("$http")
const pid = route.params.id
const $store: any = inject('$store')
const currencyUnit:String = $store.getSymbol();

const order_info: Ref<orderInfo | null> = ref(null)

  
/**
 * 获取代付订单信息
 */
const getReplaceFn = async () => {
  let reg = await $http.getReplace(pid);
  if (reg.code === 200) {
    order_info.value = reg.data
  }
}
getReplaceFn()

/**
 * 跳转支付 
 */
const actv_pay_fn = () => {
  window.location.href = order_info?.value?.pay_url || ''
}

/**
 * 头像默认图片
 */
const img_error_fn = (event: any) => {
  event.currentTarget.setAttribute("src", 'https://image.kilimall.com/kenya/PcImages/message/icon_user_header.png')
}

/**
 * 跳转商品详情页
 */
const actv_goods_fn = (item: any) => {
  router.push('/goods/' + item.goods_id)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            onError: img_error_fn,
            src: order_info.value?.member.avatar_url || ' '
          }, null, 40, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(order_info.value?.member.name || order_info.value?.member.username  || ''), 1),
          _hoisted_8
        ])
      ]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
        : _createCommentVNode("", true),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          (order_info.value?.status === 10)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Pending payment"))
            : (order_info.value?.status === 20)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
              : (order_info.value?.status === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["order-price", {'over' : order_info.value?.status !== 10}])
        }, _toDisplayString(_unref(currencyUnit) + ' ' + (order_info.value?.amount || '')), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _hoisted_28,
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((order_info.value?.goods_list || []), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (actv_goods_fn(item)),
            class: "product-item"
          }, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("img", {
                src: item.image
              }, null, 8, _hoisted_33)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, _toDisplayString(item.goods_name), 1),
              _createElementVNode("div", _hoisted_36, "x " + _toDisplayString(item.goods_num), 1)
            ])
          ], 8, _hoisted_31))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_37, [
        (order_info.value?.status === 10)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              id: "clickToFriendsHelpPay",
              onClick: actv_pay_fn,
              class: "submit-btn"
            }, "Help My Friend to Pay"))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_38
  ]))
}
}

})